module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-251.08f6934.woff2";